module.exports = __webpack_public_path__ + "static/img/11.f182836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/11.png
// module id = bUpc
// module chunks = 1